









































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiPartenaire from '@/api/partenaire'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire'
import { getDefaultAloFluxBuilder } from '@/models/alo/AloFluxBuilder'
import * as rules from '@/utils/validationRules'
//@ts-ignore
import VJsoneditor from 'v-jsoneditor/src/index'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'ModifyFluxBuilders', 
  props: {
    bldId:Number
  },
  components: { CheckState,VJsoneditor},
})

export default class ModifyFluxBuilders extends Vue {
  bldId!: number
  private showError = false    
  private loading = false
  private saving = false
  private modified = getDefaultAloFluxBuilder()

  get fluxBuilder(){
    return this.$store.myGetters.fluxBuilders[this.bldId] || getDefaultAloFluxBuilder()
  }

  get json(){
    return JSON.parse(this.modified.bldJsonParam)
  }

  set json(newValue){
    this.modified.bldJsonParam = JSON.stringify(newValue)
  }

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  loadFluxBuilder() {       
    if(this.bldId != 0) {
      this.loading = true
      this.$store.myActions.CATALOGUE_FLUXBUILDER_DETAIL_REQUEST(this.bldId).then((fluxBuilder) =>{
        this.modified = {...getDefaultAloFluxBuilder(), ...cloneDeep(fluxBuilder)}
      })
      .finally(() => {        
        this.loading = false
      })    
    }
  }

  get isDirty() {
    return !deepEqual(this.fluxBuilder,this.modified)
  }

  created(){    
    this.loadFluxBuilder()
  }

  get arianeItems() {
    const arianeItems =  [
        {
          text: 'Data sources',
          disabled: false,          
          to: "/admin/fluxBuilders",
          exact:true
        }
      ]
    if(this.fluxBuilder) {
        arianeItems.push({
          text: this.fluxBuilder.libelle,
          disabled: true,          
          to: "",
          exact:true
        })
    }
    return arianeItems;
  } 

  get fluxBuildersStatus() {
    return this.$store.myGetters.fluxBuildersStatus        
  }
  

  saveData() {
    if ((this.$refs.editFluxBuilderForm as HTMLFormElement).validate()) {
      this.saving = true       
      const redirect = this.modified.id != this.modified.newId
      this.$store.myActions.CATALOGUE_FLUXBUILDER_SAVE_REQUEST(this.modified).then((savedSataSource:any) => {
        this.modified = cloneDeep(savedSataSource)
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.fluxBuildersStatus)                  
        if(redirect) this.$router.push({name:'ModifyFluxBuilders',params:{bldId:savedSataSource.id}})        
      }).finally(()=> {
        this.saving = false
      })    
    }
  }

  deleteFluxBuilder(){
    if(this.bldId != 0) {      
       this.$confirm("Voulez vous vraiment supprimer ce flux builder?",{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.CATALOGUE_FLUXBUILDER_DELETE_REQUEST(this.bldId).then(() => {
            this.$router.push({name:'FluxBuilders'})
          })
        } 
      })          
    } 
  }

  cancelFluxBuilder(){
    if(this.bldId == 0) this.modified = getDefaultAloFluxBuilder()
    else this.loadFluxBuilder()
  }

}
